import { render, staticRenderFns } from "./MemoriaCalculoTab.vue?vue&type=template&id=025674c2&"
import script from "./MemoriaCalculoTab.vue?vue&type=script&lang=js&"
export * from "./MemoriaCalculoTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports